import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portal-list-surface',
  templateUrl: './portal-list-surface.component.html',
  styleUrls: ['./portal-list-surface.component.scss'],
})
export class PortalListSurfaceComponent {
  @Input() title = '';
  @Input() subtitle = '';
}
